export default __webpack_public_path__ + "static/media/feather.29ae6507.svg";